
import XHeader from 'vux/src/components/x-header/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import global from '../../../static/js/global.js'
export default {
components: {
XHeader,
LoadMore
},
data() {
return {
content: '',
title: '',
totals: '',
createTime: '',
}
},
beforeMount() {
let urlnotice = global.host + 'news/getNewsById?id=' + this.$router.history.current.query.newid + '&pageNum=1';
this.$http.get(urlnotice).then(function (res) {
if (res.body.result) {
console.log(res);
this.content = res.body.result.content + "<style>img{widht:100%;max-width:100%;height:auto;}</style>";
this.title = res.body.result.title;
this.totals = res.body.result.totals;
this.createTime = res.body.result.createTime;
this.changeReadNum();
}
}, function (err) {
console.log(res)
})
},
methods: {
changeReadNum(){
let usInfo = new Object();
usInfo.comnCode = this.$router.history.current.query.comnCode;
usInfo.openId = this.$router.history.current.query.openid;
usInfo.phoneNo = this.$router.history.current.query.phone;
usInfo.sourceId = this.$router.history.current.query.newid;
usInfo.uvSource = 'notice';
console.log("%%%%%%%%%%%%%");
console.log(usInfo.sourceId);
let urls = global.host + "news/readnumber";
this.$http.post(urls, usInfo).then(
function (res) {
console.log(res);
},
function (err) {
console.log(err);
}
);
}
}
}



// WEBPACK FOOTER //
// ./src/components/newComponents/notice_list.vue